import { ref } from 'vue'

import type { PjazzaReservationSlot } from '@/domains/pjazza/types/models/PjazzaReservation.types.ts'

import { callPjazzaReservations } from '@/domains/pjazza/services'

/**
 * D1's own first screen. Fetched once, on arrival — there is nothing yet
 * for the diner to have answered that would change tonight's own two
 * slots or tomorrow evening's first.
 */
export const useTonightOffers = (siteSlug: string) => {
  const isLoading = ref(true)
  const offers = ref<PjazzaReservationSlot[]>([])

  const fetch = async (): Promise<void> => {
    isLoading.value = true

    try {
      const response = await callPjazzaReservations().tonightOffers({ siteSlug })

      offers.value = response.data.value?.data.offers ?? []
    } catch {
      // A failed read here is silent: it just leaves nothing to offer, and
      // the ghost button underneath reaches the ordinary picker regardless.
      offers.value = []
    } finally {
      isLoading.value = false
    }
  }

  return { isLoading, offers, fetch }
}
